import React, { useEffect, useState } from "react";

const OpenApp = () => {
  const [deepLinkUrl, setDeepLinkUrl] = useState("oavana://home");
  useEffect(() => {
    console.log(window.location);
    // const hash = window.location.hash // "#/open?token=eyJhbGci..."
    // const queryString = hash.split('?')[1] // "token=eyJhbGci..."
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    let url = "oavana://home";
    if (token) {
      console.log("token ", token);
      const query = new URLSearchParams();
      if (token) query.append("token", token);
      url += `?${query.toString()}`;
    }

    setDeepLinkUrl(url);
    console.log("url ", url);
    window.location.href = url;
  }, []);

  return (
    <div>
      <p>
        If the app doesn’t open automatically,{" "}
        <a href={deepLinkUrl}>click here</a>.
      </p>
    </div>
  );
};

export default OpenApp;
